// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__bsRAS","col":"styles_col__12LdA"};